import { cn } from '@/lib/utils';

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-md bg-outlines/70', className)} />;
}

interface TableSkeletonProps {
  rows?: number;
  cols?: number;
  bordered?: boolean;
  className?: string;
}

export function TableSkeleton({ rows = 6, cols = 5, bordered = true, className }: TableSkeletonProps) {
  return (
    <div
      className={cn(
        bordered && 'overflow-hidden rounded-[var(--radius-card)] border border-outlines bg-white',
        className,
      )}
    >
      <div className="flex gap-6 border-b border-outlines bg-subtle-bg px-5 py-3.5">
        {Array.from({ length: cols }).map((_, i) => (
          <Skeleton key={i} className={cn('h-3 flex-1', i === cols - 1 && 'max-w-16')} />
        ))}
      </div>
      <div className="divide-y divide-subtle-bg">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className="flex items-center gap-6 px-5 py-4">
            {Array.from({ length: cols }).map((_, c) => (
              <Skeleton
                key={c}
                className={cn('h-4 flex-1', c === 0 && 'max-w-[28%]', c === cols - 1 && 'max-w-16')}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
